import {
    UserLayout,
    BasicLayout,
    PageHead,
    PageRecharge,
    PageNoHead
} from '@/components/layout'

export const constantRouterMap = [{
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [{
        path: 'login',
        name: 'login',
        component: () => import('@/views/login')
    }]
}]

export const asyncRouterMap = [{
    path: '/',
    component: BasicLayout,
    redirect: '/home/index',
    meta: { title: '首页' },
    children: [{
        path: '/home',
        redirect: '/home/index',
        component: PageNoHead,
        inLeftMenu: false,
        children: [{
            path: '/home/index',
            component: () => import('@/views/analysis.vue')
        }]
    }, {
        path: '/recharge',
        redirect: '/recharge/phone',
        component: PageRecharge,
        meta: {
            title: '充值中心',
            icon: 'el-icon-date'
        },
        noChildMenu: true,
        children: [{
            path: '/recharge/phone',
            component: () => import('@/views/phone.vue'),
            meta: {
                title: '话费充值',
                icon: 'el-icon-date'
            }
        }, {
            path: '/recharge/flow',
            component: () => import('@/views/phone.vue'),
            meta: {
                title: '流量充值',
                icon: 'el-icon-date'
            }
        }, {
            path: '/recharge/qqcz',
            component: () => import('@/views/phone.vue'),
            meta: {
                title: 'QQ充值',
                icon: 'el-icon-date'
            }
        }, {
            path: '/recharge/wycz',
            component: () => import('@/views/phone.vue'),
            meta: {
                title: '网游充值',
                icon: 'el-icon-date'
            }
        }, {
            path: '/recharge/ghcz',
            component: () => import('@/views/phone.vue'),
            meta: {
                title: '固话充值',
                icon: 'el-icon-date'
            }
        }, {
            path: '/recharge/kdcz',
            component: () => import('@/views/phone.vue'),
            meta: {
                title: '宽带充值',
                icon: 'el-icon-date'
            }
        }, {
            path: '/recharge/xyc',
            component: () => import('@/views/phone.vue'),
            meta: {
                title: '信用卡还款',
                icon: 'el-icon-date'
            }
        }, {
            path: '/recharge/jyk',
            component: () => import('@/views/phone.vue'),
            meta: {
                title: '加油卡',
                icon: 'el-icon-date'
            }
        }, {
            path: '/recharge/hfc',
            component: () => import('@/views/phone.vue'),
            meta: {
                title: '话费卡',
                icon: 'el-icon-date'
            }
        }, {
            path: '/recharge/life',
            component: () => import('@/components/sc.vue'),
            meta: {
                title: '生活缴费',
                icon: 'el-icon-date'
            }
        }]
    }, {
        path: '/card',
        redirect: '/card/release',
        component: PageHead,
        meta: {
            title: '卡券核销',
            icon: 'el-icon-date'
        },
        children: [{
            path: '/card/release',
            component: () => import('@/views/card/release.vue'),
            meta: { title: '卡券发布' }
        }, {
            path: '/card/manage',
            component: () => import('@/views/card/manage.vue'),
            meta: { title: '卡券管理' }
        }]
    }, {
        path: '/order',
        component: PageHead,
        redirect: '/order/index',
        meta: {
            title: '订单管理',
            icon: 'el-icon-date'
        },
        noChildMenu: true,
        children: [{
            path: '/order/index',
            component: () => import('@/views/order.vue')
        }]
    }, {
        path: '/oto',
        component: PageHead,
        meta: {
            title: 'oto收银台',
            icon: 'el-icon-date'
        }
    }, {
        path: '/account',
        component: () => import('@/views/account.vue'),
        meta: {
            title: '账户管理',
            icon: 'el-icon-date'
        }
    }, {
        path: '/setting',
        component: PageHead,
        meta: {
            title: '系统设置',
            icon: 'el-icon-date'
        }
    }]
}]
